import { Validators } from '@angular/forms';

import { PhoneNumberUtil } from '../utils';

const emailFormatValidator = Validators.pattern(
    /^((?:[a-zA-Z0-9_+-]+\.)+)?[a-zA-Z0-9_+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,10}$/,
);

const phoneFormatValidator = Validators.pattern(PhoneNumberUtil.LENGTH_AND_FORMAT_RULE_VALIDATOR_REGEXP);

export const EcmFormValidators = {
    emailFormatValidator,
    phoneFormatValidator,
};
